import { Box, Button, Dialog, Typography } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState
} from "react";
import { useIntl } from "react-intl";

const useStyle = makeStyles(
  () => ({
    dialog: {
      width: "420px",
      height: "242px",
      padding: "32px 24px 32px 24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      fontSize: 18,
      width: "178px",
      height: "48px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },
    fileResult: {
      paddingTop: "24px",
      paddingBottom: "32px",
      fontSize: "16px",
      fontWeight: 400
    }
  }),
  { name: "DialogSuccess" }
);

export interface IRefDialogSuccess {
  onOpen: (filename: string) => void;
  visible: boolean;
  onClose: () => void;
}

const DialogSuccess: ForwardRefRenderFunction<IRefDialogSuccess> = (
  _props,
  ref
) => {
  const classes = useStyle();
  const intl = useIntl();

  const [visible, setVisible] = useState<boolean>(false);
  const [filename, setFilename] = useState<string>();
  const onClose = () => setVisible(false);

  const onOpen = (e: string) => {
    setFilename(e);
    setVisible(true);
  };

  useImperativeHandle(ref, () => ({ onOpen, onClose, visible }));

  return (
    <Dialog open={visible} keepMounted onClose={onClose}>
      <Box className={classes.dialog} display="flex" flexDirection={"column"}>
        <Typography className={classes.title}>
          {intl.formatMessage({
            defaultMessage: "การอัพโหลดไฟล์สำเร็จ",
            description: "title"
          })}
        </Typography>
        <Typography className={classes.fileResult}>
          {filename}
          {intl.formatMessage({
            defaultMessage:
              " อัพโหลดเสร็จสมบูรณ์ กรุณารอยืนยันใบสั่งซื้อทาง e-mail",
            description: "file"
          })}
        </Typography>

        <Button className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage({
              defaultMessage: "ปิด",
              description: "close"
            })}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default forwardRef(DialogSuccess);
